// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__J+omT","Loading":"Loader_Loading__h+38U","Spinner":"Loader_Spinner__ufTSO","Spinner-spin":"Loader_Spinner-spin__1TxeN"};